<template>
  <div :docInfo="serviceInfo" is="docAndService"></div>
</template>
<script>
import docAndService from "@/components/common/basicDocAndService.vue";
export default {
  components: { docAndService },
  data() {
    return {
      serviceInfo: {
        title: "服务能力",
        docId: null,
      },
    };
  },
  created() {
    this.$_setTitle('服务能力-开放平台');
    this.serviceInfo.docId = this.$route.query.docId;
  },
  methods: {},
};
</script>
<style lang="scss">
</style>